
import { useStore } from '@/store'
import {
    BetItem,
    computed,
    defineComponent,
    Emitter,
    HallData,
    inject,
    onBeforeMount,
    onBeforeUnmount,
    onMounted,
    PropType,
    ref,
    ResponseData,
    ResultMemberList,
    SocketMessage,
    TableData,
    TableDetails,
    UserInfo,
    watch
} from 'vue'
import RoadMap from '@/components/roadmap/index.vue'
import DPrediction from '@/components/d-prediction.vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { EventBuss, HALL, SOCKET_MESSAGE } from '@/types/global'
import { AppMutation } from '@/store/types'
import { RoadMapData } from '@/components/roadmap/datamodel/RoadMapData'
import { parseRoadMap } from '@/components/roadmap/utils'
import { RoadMapSummaryData } from '@/components/roadmap/datamodel/types'
import { VTextMarquee } from 'vue-text-marquee'
import { Dictionary } from '@/types/dictionary'
import { GameResult } from '@/types/GameResult'
import CardGameResult from '@/components/d-card-result.vue'
import CardPreviewResult from '@/components/card-result-preview.vue'
import mCardResult from '@/components/controls/m-card-result.vue'
import {
    ConfirmBetButton,
    CancelBetButton,
    RepeatBetButton
} from '@/components/svg'
import {
    AxiosSource,
    callGunner,
    flyBet,
    getTableDetail,
    openPokeRequest,
    operatStatus,
    pauseRequest
} from '@/api'
import axios from 'axios'
import { ROUTES } from '@/router'
import {
    IArrowH,
    IBalance,
    IUserL,
    IReloadG,
    ICard,
    IDiamond,
    IBalanceG,
    IHome,
    IFull,
    INormal,
    // IconPlayG,
    IconOpenCardG,
    IconPauseG,
    icon4sq,
    iconMenu,
    iconReturn,
    iconAudio,
    iconVideo
} from '@/components/icons'
import { MessageBoxActionType, MessageBoxEvent } from '@/types/MessageBox'

import audioPlayer, { SOUNDKEY } from '@/utils/sounds'
import SwitchTable from '@/components/switch-table.vue'
import CtrlChips from '@/components/ctrl-chips.vue'
import CtrlBetBoxGroup from '@/components/ctrl-bet-box-group.vue'
import { joinTable as changeTable } from '@/api'
import screenfull from 'screenfull'
import mPrediction from '@/components/controls/m-prediction.vue'
import { getCookieValue } from '@/utils'
import { CookiesToken } from '@/types/CookiesToken'

export default defineComponent({
    props: {
        desk: {
            default: -1,
            type: Number as PropType<number>
        }
    },
    components: {
        'road-map': RoadMap,
        'd-prediction': DPrediction,
        'm-prediction': mPrediction,
        // 'media-control': MediaControl,
        'marquee-text': VTextMarquee,
        // 'desk-switcher': DeskSwitcher,
        // 'simple-game-result': SimpleGameResult,
        'card-game-result': CardGameResult,
        'm-card-result': mCardResult,
        IArrowH,
        IBalance,
        IUserL,
        IReloadG,
        ICard,
        IDiamond,
        IBalanceG,
        IHome,
        INormal,
        IFull,
        SwitchTable,
        CtrlChips,
        CtrlBetBoxGroup,
        // IconPlayG,
        IconOpenCardG,
        IconPauseG,
        CardPreviewResult,
        'icon-4sq': icon4sq,
        'icon-menu': iconMenu,
        'icon-return': iconReturn,
        'icon-audio': iconAudio,
        'icon-video': iconVideo,
        'confirm-bet-button': ConfirmBetButton,
        'cancel-bet-button': CancelBetButton,
        'repeat-bet-button': RepeatBetButton
    },
    setup(props) {
        const store = useStore()
        const { t } = useI18n()
        const router = useRouter()
        const route = useRoute()
        const emitter = inject('emitter') as Emitter
        const currentCount = ref<number>(-1)
        const deskMapKey = ref<number>(new Date().getTime())
        const refBetGroup = ref<any>()
        const isRepeatBetClicked = ref(false)
        const refFullVideo = ref()
        const refMinVideo = ref()
        const refVideoContainer = ref()
        const isFreeBaccarat = ref(false)
        const allowToggleGameMode = ref(false)
        const enableFreeBaccarat = ref(false)


        const roadmapview1 = ref<typeof RoadMap | undefined>(undefined)
        const roadmapview2 = ref<typeof RoadMap | undefined>(undefined)
        const deskData = ref<TableDetails | undefined>(undefined)
        const roadMapData = ref<RoadMapData>(parseRoadMap([]))
        const nextRedRoadMapSummaryData = ref<RoadMapSummaryData>({})
        const nextBlueRoadMapSummaryData = ref<RoadMapSummaryData>({})
        const deskVideoOn = ref<boolean>(false)
        const showResultPreview = ref<boolean>(false)

        const showSwitcher = ref<boolean>(false)
        const hasJoinRequest = ref<boolean>(false)
        const showMobileFunctionControls = ref(false)

        const isScaleVideo = ref<boolean>(false)
        const deskNoticeKey = ref<number>(new Date().getTime())
        const deskNotice = ref<string>('')
        const isFullVideo = ref(false)

        let serviceTimeOut: boolean | number = false
        let countDownInterval: boolean | number = false
        let betEndTime = 0
        let resyncTimer: number | boolean = false

        // video variables
        let videoPlayerCollection: Array<any> = new Array<any>()
        let nodePlayer!: any
        const isLoadingVideo = ref<boolean>(true)
        let videoReconnectTimer: number | false = false
        let videoBufferEmptyTimer: number | false = false
        let videoReconnectAttempts = 0
        let isDisposingVideo = false
        let lastStartedVideoUrl = ''
        const MAX_VIDEO_RECONNECT = 8
        const VIDEO_STALL_TIMEOUT_SEC = 10
        const VIDEO_BUFFER_EMPTY_MS = 5000

        let currentGameId: string | undefined = undefined
        let needRefreshGameResult = true
        let showCardTimeout: number | boolean = false
        let currentGameResult: GameResult | undefined = undefined
        const showSimpleResult = ref<boolean>(false)
        const showCardDisplay = ref<boolean>(false)
        const showMediaControl = ref<boolean>(false)
        const showSwitchDesk = ref<boolean>(false)
        const betViewKey = ref<number>(new Date().getTime())

        const cardResultKey = ref<number>(Date.now())
        const isPokerOpenFlag = ref(3)

        const hasUnConfirmedBet = ref(false)

        let isLoadingCallGunner = false

        let deskId = -1
        let loadDataFailedCounter = 0
        let loadDataRequestId = 0

        let timeOutCount = 5
        let clientTimeOutSession: any = false
        let clientTimeOutStarted = false

        const enableOpenPoker = ref<boolean>(false)
        let calledOpenPokeCounter = 0

        //#region Vue Helpers
        onMounted(() => {
            deskId = props.desk
            deskVideoOn.value = videoIsOn.value
            loadData()

            setTimeout(() => {
                showMediaControl.value = true
            }, 1000)


            // start user game time out countdown
            // startGameTimeOut()
            // TODO: Uncomment this when we have a proper time out mechanism
        })
        onBeforeMount(() => {

            enableFreeBaccarat.value = String(process.env.ENABLE_FREE_BACCARAT).toLowerCase() === 'true'

            if (props.desk <= 0) {
                router.push({ name: ROUTES.LOBY })
                return
            }

            // if (isFreeUser.value) {
            //     if (visitorTable.value.indexOf(props.desk) === -1) {
            //         router.push({ name: ROUTES.LOBY })
            //         return
            //     }
            // }

            emitter.on(EventBuss.PAGE_ON_VISIBLE, handleOnPageActive)
            emitter.on(EventBuss.SOCKET_RECONNECTED, handleOnSocketReconnected)

            // emitter.on(EventBuss.SESSION_EXPIRED, handleOnExpiredSession)
            emitter.on(EventBuss.WINDOW_RESIZED, handleOnWindowResize)
            // listen to websocket events
            emitter.on(EventBuss.SOCKET_MESSAGE, handleSocketMessage)
        })

        onBeforeUnmount(() => {
            stopCountDown()
            stopService()
            disposeVideoPlayer()

            if (typeof resyncTimer === 'number') {
                clearTimeout(resyncTimer)
                resyncTimer = false
            }

            emitter.off(EventBuss.PAGE_ON_VISIBLE, handleOnPageActive)
            emitter.off(EventBuss.SOCKET_RECONNECTED, handleOnSocketReconnected)
            emitter.off(EventBuss.WINDOW_RESIZED, handleOnWindowResize)
            emitter.off(EventBuss.SOCKET_MESSAGE, handleSocketMessage)
        })
        //#endregion

        // #region HELPERS
        const startGameTimeOut = () => {
            const whiteList = String(process.env.USER_WHITE_LIST).split(',')
            if (whiteList.indexOf(userInfo.value.code.toLowerCase()) === -1) {
                // console.log('client timeout startted')
                clientTimeOutStarted = true
                reduceClientTimeOut()
            }
        }

        const stopClientTimeOut = () => {
            if (typeof clientTimeOutSession === 'number') {
                clearTimeout(clientTimeOutSession)
                clientTimeOutSession = false
                clientTimeOutStarted = false
            }
        }

        const reduceClientTimeOut = () => {
            clientTimeOutSession = setTimeout(() => {
                timeOutCount--
                // console.log(`Counting:${timeOutCount}`)
                if (timeOutCount <= 0) {
                    stopClientTimeOut()
                    // redirect to login
                    router.push({ name: ROUTES.LOBY })
                } else {
                    reduceClientTimeOut()
                }
            }, (5000 * 60) / 5)
        }

        //#endregion

        // const isActiveTableOption = (id: number) => {
        //     return props.desk === id
        // }

        const resyncGameState = () => {
            if (router.currentRoute.value.name !== ROUTES.GAME) return

            if (typeof resyncTimer === 'number') {
                clearTimeout(resyncTimer)
            }

            resyncTimer = window.setTimeout(() => {
                resyncTimer = false
                loadData(true)
            }, 300)
        }

        const handleOnSocketReconnected = () => {
            resyncGameState()

            if (deskVideoOn.value && deskData.value?.gameTable.cmccLine) {
                initVideoPlayer(true)
            }
        }

        const handleOnPageActive = () => {
            if (router.currentRoute.value.name !== ROUTES.GAME) {
                // console.log('Not in game page, skip reloading data')
                return
            }

            refBetGroup.value?.hideBetViewResult()

            showCardDisplay.value = false
            showResultPreview.value = false
            disposeVideoPlayer()

            if (betEndTime > 0) {
                const remaining = Math.ceil((betEndTime - Date.now()) / 1000)
                if (remaining >= 0) {
                    currentCount.value = remaining
                }
            }

            resyncGameState()

            if (deskVideoOn.value && deskData.value?.gameTable.cmccLine) {
                initVideoPlayer(true)
            }

            // console.log('Game Page Active')
        }

        const loadData = (_forceReload = false) => {
            if (deskId <= 0) {
                router.push({ name: ROUTES.LOBY })
                return
            }

            const requestId = ++loadDataRequestId

            const _params = {
                memberId: memberid.value,
                tableId: deskId,
                token: token.value
            }
            // console.log('loadData', _params)

            if (!_forceReload) store.commit(AppMutation.SHOW_LOADING)
            getTableDetail(_params)
                .then((_response) => {
                    if (requestId !== loadDataRequestId) return

                    loadDataFailedCounter = 0
                    if (!_forceReload) store.commit(AppMutation.HIDE_LOADING)
                    const responseData =
                        _response.data as ResponseData<TableDetails>

                    // console.log('responseData', responseData)

                    if (responseData.status === 200) {
                        const { noticeList, gameTable } = responseData.data!


                        if (gameTable.gameTypeNo === 'G002' && !highlightSwitchPlayMode.value) {
                            switchPlayMode()

                        }


                        if (gameTable.reserverd === 1) {
                            if (userInfo.value && gameTable.visitCode) {
                                const visitCodes =
                                    gameTable.visitCode.split(',')
                                if (
                                    gameTable.visitCode === '' ||
                                    visitCodes.indexOf(userInfo.value.code) ==
                                    -1
                                ) {
                                    kickUserOffTheTable()
                                    return
                                }
                            }
                        }

                        let _deskNotice = ''
                        noticeList.forEach((_notice, index) => {
                            if (index === 0) _deskNotice = _notice.content
                            else
                                _deskNotice = `${_deskNotice},   ${_notice.content}`
                        })
                        deskNotice.value = _deskNotice
                        deskNoticeKey.value = new Date().getTime()

                        deskData.value = responseData.data!

                        store.commit(
                            AppMutation.SET_COIN,
                            deskData.value.gameTable.expand.amount
                        )
                        roadMapData.value = parseRoadMap(
                            deskData.value.gameTable.expand.resultList
                        )

                        store.commit(
                            AppMutation.SET_IS_GUNNER,
                            responseData.data?.isGunner
                        )

                        if (
                            responseData.data!.gameTable.expand.memberStatus ===
                            3
                        ) {
                            store.commit(
                                AppMutation.SET_DESK,
                                responseData.data!.gameTable.id
                            )
                        }

                        setTimeout(() => {
                            if (refBetGroup.value) {
                                refBetGroup.value.resetBetUI()

                                if (
                                    deskData.value &&
                                    deskData.value.gameTable.expand.betFormList
                                ) {
                                    if (deskData.value.gameTable.status === 1) {
                                        deskData.value.gameTable.expand.betFormList.forEach(
                                            (i) => {
                                                if (
                                                    i.memberId ===
                                                    memberid.value
                                                ) {
                                                    enableOpenPoker.value = true
                                                    // fix open card
                                                    isPokerOpenFlag.value = 4
                                                }
                                            }
                                        )
                                    }
                                }
                            }
                        }, 250)

                        if (
                            _forceReload &&
                            deskData.value.gameTable.expand.daoJiShiBetTime > 0
                        ) {
                            startCountDown(true)
                        }

                        if (deskVideoOn.value) {
                            const videoUrl = deskData.value.gameTable.cmccLine
                            if (videoUrl !== lastStartedVideoUrl) {
                                initVideoPlayer()
                            }
                        }
                    } else if (responseData.status === 301) {
                        // token is expired
                        // reset
                        emitter.emit(
                            EventBuss.TOAST_MESSAGE,
                            responseData.description!
                        )
                        emitter.emit(EventBuss.SOCKET_CLOSE)
                        store.commit(AppMutation.CLEAR_ALL)
                        router.push({ name: ROUTES.LOGIN })
                    } else {
                        emitter.emit(
                            EventBuss.TOAST_MESSAGE,
                            responseData.description!
                        )
                    }
                })
                .catch((e) => {
                    if (requestId !== loadDataRequestId) return

                    if (!_forceReload) store.commit(AppMutation.HIDE_LOADING)

                    // emitter.emit(EventBuss.TOAST_MESSAGE, '网络错误')

                    loadDataFailedCounter++
                    if (loadDataFailedCounter > 3) {
                        emitter.emit(
                            EventBuss.SMALL_TOAST,
                            t('prompts.networkerror')
                        )

                        store.commit(AppMutation.CLEAR_ALL)
                        emitter.emit(EventBuss.SOCKET_CLOSE)
                        router.push({ name: ROUTES.LOGIN })
                    } else {
                        // reload after 1 second
                        setTimeout(() => {
                            loadData(true)
                            // console.log(
                            //     `Retrying to load data, attempt #${loadDataFailedCounter}`,
                            //     e
                            // )
                        }, 1500)
                    }
                })
        }

        const stopService = () => {
            if (AxiosSource) {
                AxiosSource.Source.cancel()
                AxiosSource.Source = axios.CancelToken.source()
            }

            if (typeof serviceTimeOut === 'number') {
                clearTimeout(serviceTimeOut)
                serviceTimeOut = false
            }
        }

        const onRoadMapDataParsed = (
            a: RoadMapData,
            b: RoadMapData,
            c: RoadMapData
        ) => {
            roadMapData.value = a
            nextRedRoadMapSummaryData.value = { data: b }
            nextBlueRoadMapSummaryData.value = { data: c }
        }

        const predict = (preType: number) => {
            if (roadmapview1.value) {
                roadmapview1.value.Predict(preType)
            }

            if (roadmapview2.value) {
                roadmapview2.value.Predict(preType)
            }
        }

        const handleOnWindowResize = () => {
            // deskMapKey.value = new Date().getTime()
            deskNoticeKey.value = new Date().getTime()
        }

        const hideSwitcher = () => {
            showSwitcher.value = false
        }

        const onToggleMediaControl = () => {
            showMediaControl.value = !showMediaControl.value
        }

        const onPlaceTempBetOrClear = (_hasTempAndConfirmBet: boolean) => {
            hasUnConfirmedBet.value = _hasTempAndConfirmBet
        }

        const onBetSuccess = () => {
            // do something
            if (
                isYoureReserved.value &&
                deskData.value!.gameTable.status === 1 &&
                isPokerOpenFlag.value === 3
            ) {
                enableOpenPoker.value = true
                isPokerOpenFlag.value = 4
            } else if (
                (!isReserved.value &&
                    deskData.value!.gameTable.status === 1 &&
                    isPokerOpenFlag.value === 3) ||
                (isReserved.value &&
                    isYoureReserved &&
                    deskData.value!.gameTable.status === 1 &&
                    isPokerOpenFlag.value === 3)
            ) {
                enableOpenPoker.value = true
                isPokerOpenFlag.value = 4
            } else if (
                userCommandType.value === 1 &&
                deskData.value!.gameTable.status === 2
            ) {
                enableOpenPoker.value = true
                isPokerOpenFlag.value = 4
            } else {
                // console.log('show')
            }
        }

        const onSwitchTable = (_tableNo: number, _desk: TableData) => {
            // check member type if 1= free user can enter all desk
            if (_desk.reserverd === 1) {
                if (
                    (userInfo.value && _desk.visitCode) ||
                    _desk.visitCode === ''
                ) {
                    const visitCodes = _desk.visitCode.split(',')
                    if (visitCodes.indexOf(userInfo.value.code) === -1) {
                        emitter.emit(
                            EventBuss.TOAST_MESSAGE,
                            t('prompts.tableisreserved')
                        )
                        return
                    }
                }
            } else if (userInfo.value.memberType !== 1) {
                if (
                    _desk.commandType !== 0 &&
                    userCommandType.value !== _desk.commandType
                ) {
                    let _toastMessage = `${_desk.tableNo}`

                    if (_desk.commandType === 1) {
                        _toastMessage += t('prompts.isphonetableselectother')
                    } else {
                        _toastMessage += t('prompts.iscommandtableselectother')
                    }
                    emitter.emit(EventBuss.TOAST_MESSAGE, _toastMessage)

                    return
                }
            }

            showSwitchDesk.value = false

            if (props.desk === _tableNo) return

            hasJoinRequest.value = false
            betViewKey.value = new Date().getTime()
            showResultPreview.value = false

            router.replace({
                query: {
                    desk: _tableNo
                }
            })

            deskId = _tableNo
            isRepeatBetClicked.value = false
            hasUnConfirmedBet.value = false
            stopCountDown()

            isScaleVideo.value = false
            deskVideoOn.value = videoIsOn.value
            disposeVideoPlayer()

            // disposeIngameToastMessage()
            // hide the card result when switching desk
            // showCardResult.value = false
            showCardDisplay.value = false
            refBetGroup.value?.hideBetViewResult()
            // bet view reload
            // betViewKey.value = new Date().getTime()
            // currentGameId = undefined

            deskData.value = undefined
            // nextRedRoadMapSummaryData.value = {}
            // nextBlueRoadMapSummaryData.value = {}
            roadMapData.value = parseRoadMap([])
            stopClientTimeOut()
            timeOutCount = 5
            loadData()

            // start user game time out countdown
            // TODO: Uncomment this when we have a proper time out mechanism
            // startGameTimeOut()
        }

        //#region Video Player Helpers
        const canPlayVideo = () => {
            return (
                deskVideoOn.value &&
                router.currentRoute.value.name === ROUTES.GAME &&
                !!deskData.value?.gameTable.cmccLine
            )
        }

        const cancelVideoReconnect = () => {
            if (typeof videoReconnectTimer === 'number') {
                clearTimeout(videoReconnectTimer)
                videoReconnectTimer = false
            }

            if (typeof videoBufferEmptyTimer === 'number') {
                clearTimeout(videoBufferEmptyTimer)
                videoBufferEmptyTimer = false
            }
        }

        const resetVideoReconnectAttempts = () => {
            videoReconnectAttempts = 0
            cancelVideoReconnect()
        }

        const scheduleVideoReconnect = () => {
            if (!canPlayVideo() || isDisposingVideo) return
            if (videoReconnectTimer !== false) return

            videoReconnectAttempts++
            if (videoReconnectAttempts > MAX_VIDEO_RECONNECT) return

            isLoadingVideo.value = true
            const delay = Math.min(1000 * videoReconnectAttempts, 8000)

            videoReconnectTimer = window.setTimeout(() => {
                videoReconnectTimer = false
                if (!canPlayVideo()) return
                initVideoPlayer(false)
            }, delay)
        }

        const bindNodePlayerEvents = (player: any) => {
            player.setTimeout(VIDEO_STALL_TIMEOUT_SEC)

            player.on('start', () => {
                resetVideoReconnectAttempts()
                isLoadingVideo.value = false
            })

            player.on('error', () => {
                if (isDisposingVideo) return
                scheduleVideoReconnect()
            })

            player.on('stop', () => {
                if (isDisposingVideo || !canPlayVideo()) return
                scheduleVideoReconnect()
            })

            player.on('timeout', () => {
                if (isDisposingVideo) return
                scheduleVideoReconnect()
            })

            player.on(
                'buffer',
                (evt: 'empty' | 'buffering' | 'full') => {
                    if (evt === 'empty' || evt === 'buffering') {
                        isLoadingVideo.value = true

                        if (
                            evt === 'empty' &&
                            typeof videoBufferEmptyTimer !== 'number'
                        ) {
                            videoBufferEmptyTimer = window.setTimeout(() => {
                                videoBufferEmptyTimer = false
                                if (isDisposingVideo || !canPlayVideo()) return
                                scheduleVideoReconnect()
                            }, VIDEO_BUFFER_EMPTY_MS)
                        }
                    } else if (evt === 'full') {
                        isLoadingVideo.value = false

                        if (typeof videoBufferEmptyTimer === 'number') {
                            clearTimeout(videoBufferEmptyTimer)
                            videoBufferEmptyTimer = false
                        }
                    }
                }
            )
        }

        const initVideoPlayer = (resetAttempts = true) => {
            if (!canPlayVideo()) return

            if (resetAttempts) {
                resetVideoReconnectAttempts()
            } else {
                cancelVideoReconnect()
            }

            isLoadingVideo.value = true
            disposeVideoPlayer()

            let isVideoConnected = false
            const videoPaths = [deskData.value!.gameTable.cmccLine]

            videoPaths.forEach((vPath) => {
                const _videoUrl = vPath

                // eslint-disable-next-line no-undef
                let _player: NodePlayer | any = new NodePlayer()

                _player.setVolume(0.0)
                _player.setView('player1')
                _player.setBufferTime(1000)
                _player.on('start', () => {
                    if (!isVideoConnected) {
                        isVideoConnected = true
                        nodePlayer = _player
                        nodePlayer.clearView()
                        nodePlayer.setView('player2')
                        bindNodePlayerEvents(nodePlayer)
                        lastStartedVideoUrl = _videoUrl
                        resetVideoReconnectAttempts()
                        isLoadingVideo.value = false
                    } else {
                        _player.clearView()
                        _player.stop()
                    }
                })
                _player.on('error', () => {
                    if (isDisposingVideo) return
                    if (!isVideoConnected) {
                        scheduleVideoReconnect()
                    }
                })
                videoPlayerCollection.push(_player)
                _player.start(_videoUrl)
            })
        }

        const disposeVideoPlayer = () => {
            isDisposingVideo = true
            cancelVideoReconnect()
            lastStartedVideoUrl = ''

            if (nodePlayer) {
                nodePlayer.stop()
                nodePlayer.clearView()
                nodePlayer = undefined
                isLoadingVideo.value = true
            }

            videoPlayerCollection.forEach((_player) => {
                if (_player) {
                    _player.clearView()
                    _player.stop()
                }
            })

            videoPlayerCollection = []
            isDisposingVideo = false
        }

        const onToggleVideo = () => {
            // if (deskVideoOn.value) {
            //     deskVideoOn.value = false
            //     disposeVideoPlayer()
            // } else {
            //     deskVideoOn.value = true
            //     if (deskData.value) initVideoPlayer()
            // }

            store.commit(AppMutation.SET_VIDEO, !deskVideoOn.value)
        }

        // const handleOnExpiredSession = () => {
        //     stopService()
        //     emitter.emit(EventBuss.TOAST_MESSAGE, '会话已过期')
        //     store.commit(AppMutation.CLEAR_ALL)
        //     router.push({ name: ROUTES.LOGIN })
        // }

        const commandType = () => {
            let cmd = ''
            if (deskData.value) {
                const { commandType } = deskData.value.gameTable
                if (commandType === 0) cmd = t('loby.universal')
                else if (commandType === 1) cmd = t('loby.phonemode')
                else if (commandType === 2) cmd = t('loby.commandmode')
            }

            return cmd
        }

        const handleOnMapPreview = (_index: number) => {
            if (
                _index >= 0 &&
                deskData.value &&
                deskData.value.gameTable.expand.gameRecordList.length >=
                _index + 1
            ) {
                if (!showResultPreview.value) showResultPreview.value = true
                const _log =
                    deskData.value.gameTable.expand.gameRecordList[_index]
                setTimeout(() => {
                    emitter.emit(EventBuss.PREVIEW_RESULT, _log)
                    // console.log(_log)
                }, 200)
            }
        }

        //#endregion

        //#region Click Method Helpers

        const switchPlayMode = () => {

            const _evt: MessageBoxEvent = {
                type: MessageBoxActionType.open,
                name: 'game-play'
            }
            emitter.emit(EventBuss.DIALOG, _evt)

        }

        const confirmBet = () => {
            if (refBetGroup.value && hasUnConfirmedBet.value) {
                refBetGroup.value.confirmTempBet()
            }
        }

        const cancelBet = () => {
            if (refBetGroup.value && hasUnConfirmedBet.value) {
                if (isRepeatBetClicked.value) isRepeatBetClicked.value = false
                refBetGroup.value.resetTempBet()
            }
        }

        const repeatBet = () => {
            if (
                refBetGroup.value &&
                canRepeatBet.value &&
                !isRepeatBetClicked.value
            ) {
                isRepeatBetClicked.value = true
                refBetGroup.value.repeatBet()
            }
        }

        const toMultibeting = () => {
            // TODO:
            router.push({ name: ROUTES.LOBY, query: { hall: HALL.MULTI } })
        }

        const toggleFullVideo = () => {
            isFullVideo.value = !isFullVideo.value
            if (isFullVideo.value) {
                // to max
                if (refVideoContainer.value && refFullVideo.value) {
                    const fullBox = refFullVideo.value as HTMLElement
                    fullBox.appendChild(refVideoContainer.value)
                }
            } else {
                // to min
                if (refVideoContainer.value && refMinVideo.value) {
                    const minBox = refMinVideo.value as HTMLElement
                    minBox.appendChild(refVideoContainer.value)
                }
            }
        }
        const requestFullScreen = () => {
            emitter.emit(EventBuss.REQUEST_FULL_SCREEN)
        }
        const toggleSoundEffect = () => {
            const _isSoundOn = soundIsOn.value ? 0 : 1
            store.commit(AppMutation.SET_SOUND, !soundIsOn.value)

            if (audioPlayer) audioPlayer.isOn = _isSoundOn
        }

        const hideSwitchTable = () => {
            showSwitchDesk.value = !showSwitchDesk.value
        }

        const joinTable = () => {
            if (isFreeUser.value) return

            if (
                deskData.value &&
                deskData.value.gameTable.reserverd === 1 &&
                userCommandType.value === 1
            ) {
                emitter.emit(
                    EventBuss.TOAST_MESSAGE,
                    t('prompts.tableisreserved')
                )
                return
            }
            // check if has a gunner
            if (!isBindToGunner.value) {
                emitter.emit(EventBuss.TOAST_MESSAGE, t('prompts.bindtogunner'))
                // 此桌已被包桌，请选择其他台桌进行投注
                return
            }

            if (hasJoinRequest.value) return

            const _params = {
                memberId: memberid.value,
                tableId: deskData.value?.gameTable.id,
                status: 5,
                token: token.value
            }
            hasJoinRequest.value = true
            store.commit(AppMutation.SHOW_LOADING)

            changeTable(_params)
                .then((response) => {
                    store.commit(AppMutation.HIDE_LOADING)
                    const _responseData = response.data as ResponseData<any>
                    if (_responseData.status !== 200) {
                        emitter.emit(
                            EventBuss.TOAST_MESSAGE,
                            _responseData.description!
                        )
                    }
                })
                .catch(() => {
                    store.commit(AppMutation.HIDE_LOADING)
                    emitter.emit(
                        EventBuss.SMALL_TOAST,
                        t('prompts.networkerror')
                    )
                })
        }

        const callGunnerFunc = () => {
            if (deskData.value && !isLoadingCallGunner) {
                const { expand, id } = deskData.value.gameTable
                const params = {
                    juNo: expand.juNo,
                    gameNo: expand.gameNo,
                    token: token.value,
                    operateType:
                        expand.callGunner && expand.callGunner === 2 ? 1 : 2,
                    memberId: userInfo.value.id,
                    tableId: id,
                    shoeNo: expand.shoeNo
                }
                isLoadingCallGunner = true
                callGunner(params)
                    .then((response) => {
                        isLoadingCallGunner = false
                        if (response.data.status === 200) {
                            if (deskData.value) {
                                if (
                                    expand.callGunner &&
                                    expand.callGunner === 2
                                ) {
                                    deskData.value.gameTable.expand.callGunner = 1
                                    emitter.emit(
                                        EventBuss.SMALL_TOAST,
                                        t('prompts.switchtoselfbettingmode')
                                    )
                                } else if (
                                    expand.callGunner &&
                                    expand.callGunner === 1
                                ) {
                                    deskData.value.gameTable.expand.callGunner = 2
                                    emitter.emit(
                                        EventBuss.SMALL_TOAST,
                                        t('prompts.switchgunerbettingmode')
                                    )
                                }
                            }
                        } else if (response.data.status === 100) {
                            emitter.emit(
                                EventBuss.SMALL_TOAST,
                                response.data.description
                            )
                        }
                    })
                    .catch(() => {
                        isLoadingCallGunner = false
                        emitter.emit(
                            EventBuss.SMALL_TOAST,
                            t('prompts.networkerror')
                        )
                    })
            }
        }

        const callOperatStatus = (_op: number) => {
            const _params = {
                memberId: memberid.value,
                tableId: deskData.value?.gameTable.id || 0,
                status: _op,
                token: token.value
            }

            store.commit(AppMutation.SHOW_LOADING)
            operatStatus(_params)
                .then((response) => {
                    store.commit(AppMutation.HIDE_LOADING)
                })
                .catch(() => {
                    store.commit(AppMutation.HIDE_LOADING)
                    emitter.emit(
                        EventBuss.SMALL_TOAST,
                        t('prompts.networkerror')
                    )
                })
        }

        const callFlyBet = () => {
            const _params = {
                memberId: memberid.value,
                tableId: deskData.value?.gameTable.id || 0,
                status: 2,
                token: token.value,
                shoeNo: deskData.value?.gameTable.expand.shoeNo || 0,
                juNo: deskData.value?.gameTable.expand.juNo || 0,
                gameNo: deskData.value?.gameTable.expand.gameNo || ''
            }
            store.commit(AppMutation.SHOW_LOADING)

            flyBet(_params)
                .then((response) => {
                    store.commit(AppMutation.HIDE_LOADING)
                    // console.log(response.data)
                })
                .catch(() => {
                    store.commit(AppMutation.HIDE_LOADING)
                    emitter.emit(
                        EventBuss.SMALL_TOAST,
                        t('prompts.networkerror')
                    )
                })
        }

        const showTipBox = () => {
            const _evt: MessageBoxEvent = {
                name: 'tipbox',
                type: MessageBoxActionType.open
            }

            emitter.emit(EventBuss.DIALOG, _evt)
        }

        const callReservedOrCancellReserved = () => {
            if (!tableCanReserved.value) return

            if (deskData.value!.isYourReserverd === 1) {
                callOperatStatus(8)
                return
            }

            if (deskData.value!.gameTable.reserverd !== -1) {
                const _evt: MessageBoxEvent = {
                    type: MessageBoxActionType.open,
                    name: 'confirm-booking'
                }

                emitter.emit(EventBuss.DIALOG, _evt)
                return
            }
        }

        const callPauseRequest = () => {
            // if(deskData.value?.gameTable.pauseStatus)
            // 其他会员暂停游戏，您没有权限继续游戏
            const _status = 18
            // deskData.value!.gameTable.pauseStatus === -1 ? 19 : 18

            // if (
            //     _status === 19 &&
            //     deskData.value!.gameTable.pauseMemberId !== memberid.value
            // ) {
            //     emitter.emit(
            //         EventBuss.TOAST_MESSAGE,
            //         '其他会员暂停游戏，您没有权限继续游戏'
            //     )
            //     return
            // }

            const _params = {
                memberId: memberid.value,
                tableId: deskData.value!.gameTable.id,
                status: _status,
                token: token.value
            }

            store.commit(AppMutation.SHOW_LOADING)

            pauseRequest(_params)
                .then((response) => {
                    store.commit(AppMutation.HIDE_LOADING)
                    if (response.data.status === 200) {
                        // if (_status === 19) {
                        //     deskData.value!.gameTable.pauseStatus = 0
                        //     deskData.value!.gameTable.pauseMemberId = 0
                        // } else if (_status === 18) {
                        deskData.value!.gameTable.pauseStatus = -1
                        deskData.value!.gameTable.pauseMemberId = memberid.value
                        // }
                        emitter.emit(
                            EventBuss.TOAST_MESSAGE,
                            t('prompts.pausegamerequestsetnt')
                        )
                    } else if (response.data.status === 100) {
                        emitter.emit(
                            EventBuss.TOAST_MESSAGE,
                            response.data.description
                        )
                    }
                })
                .catch(() => {
                    store.commit(AppMutation.HIDE_LOADING)
                    emitter.emit(
                        EventBuss.SMALL_TOAST,
                        t('prompts.networkerror')
                    )
                })
        }

        const callOpenPokeRequest = () => {
            if (calledOpenPokeCounter === 0) {
                const _params = {
                    memberId: memberid.value,
                    tableId: deskData.value!.gameTable.id,
                    status: 15,
                    token: token.value
                }
                store.commit(AppMutation.SHOW_LOADING)

                calledOpenPokeCounter += 1
                openPokeRequest(_params)
                    .then((response) => {
                        store.commit(AppMutation.HIDE_LOADING)
                        if (response.data.status === 100) {
                            emitter.emit(
                                EventBuss.TOAST_MESSAGE,
                                response.data.description
                            )
                        } else {
                            // value 3 dont show not sent open request yet
                            /// on success bet chek if value is 3  then change is to 4 4 need to show
                            // on click the request change to 2 to no need show
                            // reset to 3 if game startt
                            isPokerOpenFlag.value = 2
                            if (deskData.value) {
                                deskData.value.gameTable.expand.openPoke = 1
                            }
                        }
                    })
                    .catch(() => {
                        calledOpenPokeCounter = 0
                        store.commit(AppMutation.HIDE_LOADING)
                        emitter.emit(
                            EventBuss.SMALL_TOAST,
                            t('prompts.networkerror')
                        )
                    })
            }
        }
        //#endregion

        //#region Timer Helper Methods
        const syncCountDownFromServer = () => {
            const serverSeconds =
                deskData.value!.gameTable.expand.daoJiShiBetTime
            if (serverSeconds <= 0) return
            currentCount.value = serverSeconds
            betEndTime = Date.now() + serverSeconds * 1000
        }

        const startCountDown = (forceSync = false) => {
            const serverSeconds =
                deskData.value!.gameTable.expand.daoJiShiBetTime
            if (serverSeconds <= 0) return

            const isNewInterval = typeof countDownInterval !== 'number'
            if (isNewInterval || forceSync) {
                syncCountDownFromServer()
            }

            if (isNewInterval) {
                if (currentCount.value > 20) {
                    audioPlayer.Play(SOUNDKEY.START_BET)
                }

                countDownInterval = setInterval(() => {
                    const remaining = Math.ceil(
                        (betEndTime - Date.now()) / 1000
                    )
                    if (remaining < 0) {
                        stopCountDown()

                        if (userCommandType.value !== 1) {
                            audioPlayer.Play(SOUNDKEY.STOP_BET)
                            emitter.emit(EventBuss.GAMESTATUS, 2)
                        }
                    } else {
                        if (
                            remaining !== currentCount.value &&
                            remaining <= 11 &&
                            remaining > 0
                        ) {
                            audioPlayer.Play(SOUNDKEY.TICK)
                        }
                        currentCount.value = remaining
                    }
                }, 1000)
            }
        }

        const stopCountDown = () => {
            if (typeof countDownInterval === 'number') {
                clearInterval(countDownInterval)
                countDownInterval = false
                currentCount.value = -1
                betEndTime = 0
                if (deskData.value) {
                    deskData.value!.gameTable.status = 2
                    deskData.value!.gameTable.expand.daoJiShiBetTime = -1
                }
            }
            enableOpenPoker.value = false
            calledOpenPokeCounter = 0
        }
        //#endregion

        const showSettingDialog = () => {
            const _evt: MessageBoxEvent = {
                type: MessageBoxActionType.open,
                name: 'setting'
            }

            emitter.emit(EventBuss.DIALOG, _evt)
        }
        //#region WebSocket
        const handleSocketMessage = (_message: SocketMessage | any) => {
            const { type, gameTable } = _message
            const _type = type.toUpperCase()


            // console.log(_message)

            if (_type === SOCKET_MESSAGE.NEW_GAME) {
                const sDesk = gameTable!
                if (isSameTable(sDesk, _type)) {
                    const _gtableCopy = { ...deskData.value!.gameTable }
                    _gtableCopy.expand.shoeNo = sDesk.expand.shoeNo
                    _gtableCopy.expand.juNo = sDesk.expand.juNo
                    _gtableCopy.expand.gameNo = sDesk.expand.gameNo
                    _gtableCopy.expand.daoJiShiBetTime =
                        sDesk.expand.daoJiShiBetTime

                    // reset all data
                    _gtableCopy.expand.betFormList = []
                    _gtableCopy.expand.xianAmount = 0
                    _gtableCopy.expand.xianDuiAmount = 0
                    _gtableCopy.expand.zhuangAmount = 0
                    _gtableCopy.expand.zhuangDuiAmount = 0
                    _gtableCopy.expand.heAmount = 0

                    _gtableCopy.expand.dragonSevenAmount = 0
                    _gtableCopy.expand.bearEightAmount = 0
                    _gtableCopy.expand.bigTigerAmount = 0
                    _gtableCopy.expand.smallTigerAmount = 0
                    _gtableCopy.expand.superSixAmount = 0

                    // reset card result
                    _gtableCopy.expand.playerOne = undefined
                    _gtableCopy.expand.playerTwo = undefined
                    _gtableCopy.expand.playerThree = undefined
                    _gtableCopy.expand.bankerOne = undefined
                    _gtableCopy.expand.bankerTwo = undefined
                    _gtableCopy.expand.bankerThree = undefined
                    _gtableCopy.expand.playerCount = undefined
                    _gtableCopy.expand.bankerCount = undefined
                    _gtableCopy.expand.whoWin = -1

                    _gtableCopy.status = 1
                    _gtableCopy.expand.stopBet = 0
                    _gtableCopy.expand.openPoke = -1
                    isPokerOpenFlag.value = 3
                    deskData.value!.gameTable = _gtableCopy
                    emitter.emit(EventBuss.GAMESTATUS, 1)
                    isRepeatBetClicked.value = false

                    allowToggleGameMode.value = true
                }
            } else if (_type === SOCKET_MESSAGE.END_GAME) {
                const sDesk = gameTable!
                if (isSameTable(sDesk, _type)) {

                    const _gtableCopy = { ...deskData.value!.gameTable }

                    _gtableCopy.expand.playerOne = sDesk.expand.playerOne
                    _gtableCopy.expand.playerTwo = sDesk.expand.playerTwo
                    _gtableCopy.expand.playerThree = sDesk.expand.playerThree
                    _gtableCopy.expand.bankerOne = sDesk.expand.bankerOne
                    _gtableCopy.expand.bankerTwo = sDesk.expand.bankerTwo
                    _gtableCopy.expand.bankerThree = sDesk.expand.bankerThree
                    _gtableCopy.expand.playerCount = sDesk.expand.playerCount
                    _gtableCopy.expand.bankerCount = sDesk.expand.bankerCount
                    _gtableCopy.expand.whoWin = sDesk.expand.whoWin
                    _gtableCopy.expand.resultList = sDesk.expand.resultList
                    _gtableCopy.expand.gameRecordList =
                        sDesk.expand.gameRecordList

                    // reset bet data
                    _gtableCopy.expand.betFormList = []
                    _gtableCopy.expand.xianAmount = 0
                    _gtableCopy.expand.xianDuiAmount = 0
                    _gtableCopy.expand.zhuangAmount = 0
                    _gtableCopy.expand.zhuangDuiAmount = 0
                    _gtableCopy.expand.heAmount = 0

                    _gtableCopy.expand.dragonSevenAmount = 0
                    _gtableCopy.expand.bearEightAmount = 0
                    _gtableCopy.expand.bigTigerAmount = 0
                    _gtableCopy.expand.smallTigerAmount = 0
                    _gtableCopy.expand.superSixAmount = 0

                    const memberResultList = sDesk.expand
                        .resultMemberList as ResultMemberList[]
                    const deskResult = new GameResult(sDesk)

                    if (process.env.ENABLE_DEBUG_LOG === 'true') {
                        logEnGameCardResult(deskResult, sDesk)
                    }

                    if (memberResultList && memberResultList.length > 0) {
                        const _memberResultInfo = memberResultList.find(
                            (x) => x.memberId === memberid.value
                        )

                        if (_memberResultInfo) {
                            store.commit(
                                AppMutation.SET_COIN,
                                _memberResultInfo.amount
                            )

                            if (_memberResultInfo.winResult !== 0) {
                                let _amtStr = '0'

                                if (_memberResultInfo.winResult > 0)
                                    _amtStr = `+${_memberResultInfo.winResult}`
                                else
                                    _amtStr = String(
                                        _memberResultInfo.winResult
                                    )

                                emitter.emit(EventBuss.SMALL_TOAST, _amtStr)
                            }
                        }
                    }

                    deskData.value!.gameTable = _gtableCopy

                    if (typeof showCardTimeout === 'number') {
                        clearTimeout(showCardTimeout)
                        showCardTimeout = false
                        showCardDisplay.value = false
                        refBetGroup.value?.hideBetViewResult()
                    }
                    cardResultKey.value = Date.now()
                    showCardDisplay.value = true
                    showCardTimeout = setTimeout(() => {
                        showCardDisplay.value = false
                        refBetGroup.value?.hideBetViewResult()
                    }, 6000)

                    if (refBetGroup.value) {
                        // refBetGroup.value.mWin.value = sDesk.expand.whoWin
                        // show betview result
                        refBetGroup.value.showBetViewResult(deskResult)
                        setTimeout(() => {
                            refBetGroup.value.endGame()
                        }, 250)
                    }
                }
            } else if (_type === SOCKET_MESSAGE.STOP_GAME) {
                const sDesk = gameTable!
                if (isSameTable(sDesk, _type)) {
                    const _gtableCopy = { ...deskData.value!.gameTable }

                    _gtableCopy.expand.daoJiShiBetTime = 0
                    _gtableCopy.status = 2
                    deskData.value!.gameTable = _gtableCopy
                    if (userCommandType.value !== 1) {
                        audioPlayer.Play(SOUNDKEY.STOP_BET)
                        emitter.emit(EventBuss.GAMESTATUS, 2)
                    }
                }
            } else if (_type === SOCKET_MESSAGE.CANCEL_GAME) {
                const sDesk = gameTable!
                if (isSameTable(sDesk, _type)) {
                    const _gtableCopy = { ...deskData.value!.gameTable }
                    _gtableCopy.status = sDesk.status

                    _gtableCopy.expand.betFormList = []
                    _gtableCopy.expand.xianAmount = 0
                    _gtableCopy.expand.xianDuiAmount = 0
                    _gtableCopy.expand.zhuangAmount = 0
                    _gtableCopy.expand.zhuangDuiAmount = 0
                    _gtableCopy.expand.heAmount = 0


                    _gtableCopy.expand.dragonSevenAmount = 0
                    _gtableCopy.expand.bearEightAmount = 0
                    _gtableCopy.expand.bigTigerAmount = 0
                    _gtableCopy.expand.smallTigerAmount = 0
                    _gtableCopy.expand.superSixAmount = 0

                    _gtableCopy.expand.stopBet = 1
                    _gtableCopy.expand.openPoke = -1

                    const memberResultList = sDesk.expand
                        .resultMemberList as ResultMemberList[]

                    if (memberResultList && memberResultList.length > 0) {
                        const _memberResultInfo = memberResultList.find(
                            (x) => x.memberId === memberid.value
                        )

                        if (_memberResultInfo) {
                            store.commit(
                                AppMutation.SET_COIN,
                                _memberResultInfo.amount
                            )

                            if (refBetGroup.value) {
                                setTimeout(() => {
                                    refBetGroup.value.endGame()
                                }, 250)
                            }
                        }
                    }

                    deskData.value!.gameTable = _gtableCopy
                }
            } else if (_type === SOCKET_MESSAGE.NEW_SHOE) {
                const sDesk = gameTable!
                if (isSameTable(sDesk, _type) && deskData.value) {
                    sDesk.expand.memberStatus =
                        deskData.value.gameTable.expand.memberStatus


                    sDesk.downLimit = deskData.value.gameTable.downLimit
                    sDesk.upLimit = deskData.value.gameTable.upLimit

                    sDesk.pairDownLimit = deskData.value.gameTable.pairDownLimit
                    sDesk.pairUpLimit = deskData.value.gameTable.pairUpLimit

                    sDesk.tieDownLimit = deskData.value.gameTable.tieDownLimit
                    sDesk.tieUpLimit = deskData.value.gameTable.tieUpLimit

                    sDesk.dragonSevenDownLimit = deskData.value.gameTable.dragonSevenDownLimit
                    sDesk.dragonSevenUpLimit = deskData.value.gameTable.dragonSevenUpLimit
                    sDesk.bearEightDownLimit = deskData.value.gameTable.bearEightDownLimit
                    sDesk.bearEightUpLimit = deskData.value.gameTable.bearEightUpLimit
                    sDesk.bigTigerDownLimit = deskData.value.gameTable.bigTigerDownLimit
                    sDesk.bigTigerUpLimit = deskData.value.gameTable.bigTigerUpLimit
                    sDesk.smallTigerDownLimit = deskData.value.gameTable.smallTigerDownLimit
                    sDesk.smallTigerUpLimit = deskData.value.gameTable.smallTigerUpLimit
                    sDesk.superSixDownLimit = deskData.value.gameTable.superSixDownLimit
                    sDesk.superSixUpLimit = deskData.value.gameTable.superSixUpLimit

                    deskData.value.gameTable = sDesk
                }
            } else if (_type === SOCKET_MESSAGE.BET) {
                const sDesk = gameTable!
                if (isSameTable(sDesk, _type) && !isStaleBetMessage(sDesk)) {
                    const _gtableCopy = { ...deskData.value!.gameTable }

                    _gtableCopy.expand.xianAmount = sDesk.expand.xianAmount
                    _gtableCopy.expand.xianDuiAmount =
                        sDesk.expand.xianDuiAmount
                    _gtableCopy.expand.zhuangAmount = sDesk.expand.zhuangAmount
                    _gtableCopy.expand.zhuangDuiAmount =
                        sDesk.expand.zhuangDuiAmount
                    _gtableCopy.expand.heAmount = sDesk.expand.heAmount

                    _gtableCopy.expand.dragonSevenAmount = sDesk.expand.dragonSevenAmount
                    _gtableCopy.expand.bearEightAmount = sDesk.expand.bearEightAmount
                    _gtableCopy.expand.bigTigerAmount = sDesk.expand.bigTigerAmount
                    _gtableCopy.expand.smallTigerAmount = sDesk.expand.smallTigerAmount
                    _gtableCopy.expand.superSixAmount = sDesk.expand.superSixAmount


                    if (sDesk.expand.memberId === memberid.value) {
                        _gtableCopy.expand.betFormList =
                            sDesk.expand.betFormList
                        store.commit(AppMutation.SET_COIN, sDesk.expand.amount)
                        // reset timeout
                        timeOutCount = 5
                        // store.commit(AppMutation.SET_CLIENT_TIME_OUT,15)
                    }
                    deskData.value!.gameTable = _gtableCopy

                    // Paint chips when bet came from elsewhere (e.g. Good Road)
                    // on the same table — amounts sync via betFormList watch,
                    // but chipsUI is local and needs resetBetUI.
                    if (
                        sDesk.expand.memberId === memberid.value &&
                        refBetGroup.value
                    ) {
                        setTimeout(() => {
                            if (canPaintConfirmedChips()) {
                                refBetGroup.value.resetBetUI()
                            }
                        }, 250)
                    }
                }
            } else if (_type === SOCKET_MESSAGE.GUNNER_BET) {
                const sDesk = gameTable!
                if (isSameTable(sDesk, _type) && !isStaleBetMessage(sDesk)) {
                    const _gtableCopy = { ...deskData.value!.gameTable }

                    _gtableCopy.expand.xianAmount = sDesk.expand.xianAmount
                    _gtableCopy.expand.xianDuiAmount =
                        sDesk.expand.xianDuiAmount
                    _gtableCopy.expand.zhuangAmount = sDesk.expand.zhuangAmount
                    _gtableCopy.expand.zhuangDuiAmount =
                        sDesk.expand.zhuangDuiAmount
                    _gtableCopy.expand.heAmount = sDesk.expand.heAmount

                    _gtableCopy.expand.dragonSevenAmount = sDesk.expand.dragonSevenAmount
                    _gtableCopy.expand.bearEightAmount = sDesk.expand.bearEightAmount
                    _gtableCopy.expand.bigTigerAmount = sDesk.expand.bigTigerAmount
                    _gtableCopy.expand.smallTigerAmount = sDesk.expand.smallTigerAmount
                    _gtableCopy.expand.superSixAmount = sDesk.expand.superSixAmount

                    if (sDesk.expand.memberId === memberid.value) {
                        _gtableCopy.expand.betFormList =
                            sDesk.expand.betFormList

                        deskData.value!.gameTable = _gtableCopy
                        store.commit(AppMutation.SET_COIN, sDesk.expand.amount)
                        // store.commit(AppMutation.SET_CLIENT_TIME_OUT,15)

                        // reset timeout
                        timeOutCount = 5

                        if (refBetGroup.value) {
                            setTimeout(() => {
                                if (canPaintConfirmedChips()) {
                                    refBetGroup.value.resetBetUI()
                                }
                            }, 250)
                        }
                    }
                }
            } else if (_type === SOCKET_MESSAGE.GUNNER_VERIFY) {
                if (
                    deskData.value &&
                    deskData.value.gameTable.id === _message.data!.tableId
                ) {
                    emitter.emit(EventBuss.SMALL_TOAST, _message.data.content)
                }

                if (_message.data!.status === 10) {
                    store.commit(AppMutation.SET_IS_GUNNER, -1)
                } else if (_message.data!.status === 5 && deskData.value) {
                    if (
                        _message.data!.tableId ===
                        deskData.value.gameTable.id &&
                        _message.data!.verifyStatus === 1
                    ) {
                        const {
                            isHavePeopleReserverd,
                            isYourReserverd,
                            tableId
                        } = _message.data!
                        deskData.value.gameTable.expand.memberStatus =
                            _message.data.gameTable.expand.memberStatus

                        if (memberid.value === _message.data!.memberId) {
                            deskData.value.isYourReserverd =
                                _message.data!.isYourReserverd
                            deskData.value.reserverdType =
                                _message.data!.reserverdType
                        }

                        if (isHavePeopleReserverd === -1)
                            deskData.value.gameTable.reserverd = 0
                        else if (isHavePeopleReserverd >= 1)
                            deskData.value.gameTable.reserverd = 1

                        deskData.value.isYourReserverd = isYourReserverd
                    } else {
                        deskData.value.gameTable.expand.memberStatus = 0
                    }

                    if (_message.data!.verifyStatus === 1) {
                        store.commit(
                            AppMutation.SET_DESK,
                            _message.data.tableId
                        )
                    }
                    hasJoinRequest.value = false
                } else if (_message.data!.status === 9) {
                    store.commit(AppMutation.SET_IS_GUNNER, 0)

                    if (deskData.value) {
                        deskData.value.gameTable.expand.memberStatus = 0
                        deskData.value.gameTable.expand.callGunner = 2
                    }

                    if (_message.data.verifyStatus === 1) {
                        store.commit(AppMutation.SET_USER_GUNNER_BIND, false)
                        emitter.emit(
                            EventBuss.TOAST_MESSAGE,
                            _message.data.content
                        )
                        router.push({ name: ROUTES.LOBY })
                    }
                } else if (
                    _message.data!.status === 8 ||
                    _message.data!.status === 3
                ) {
                    const {
                        isHavePeopleReserverd,
                        isYourReserverd,
                        tableId,
                        reserverdType
                    } = _message.data!
                    if (
                        deskData.value &&
                        deskData.value.gameTable.id === tableId &&
                        _message.data!.verifyStatus === 1
                    ) {
                        if (isHavePeopleReserverd === -1)
                            deskData.value.gameTable.reserverd = 0
                        else if (isHavePeopleReserverd >= 1)
                            deskData.value.gameTable.reserverd = 1

                        deskData.value.isYourReserverd = isYourReserverd
                        deskData.value.reserverdType = reserverdType

                        if (
                            _message.data!.status === 8 &&
                            _message.data!.memberId === userInfo.value.id &&
                            isHavePeopleReserverd !== -1
                        ) {
                            kickUserOffTheTable()
                        }
                    }
                } else if (_message.data!.status === 17) {
                    if (
                        deskData.value &&
                        deskData.value.gameTable.id === _message.data!.tableId
                    ) {
                        if (memberid.value === _message.data!.memberId) {
                            deskData.value.isYourReserverd =
                                _message.data!.isYourReserverd
                        }

                        if (_message.data!.isHavePeopleReserverd === -1) {
                            deskData.value.gameTable.reserverd = 0
                            deskData.value.reserverdType = undefined
                        } else if (_message.data!.isHavePeopleReserverd === 1) {
                            deskData.value.gameTable.reserverd = 1
                            deskData.value.reserverdType =
                                _message.data!.reserverdType
                        }
                    }
                } else if (_message.data!.status === 16) {
                    if (
                        deskData.value &&
                        deskData.value.gameTable.id === _message.data!.tableId
                    ) {
                        if (memberid.value === _message.data!.memberId) {
                            deskData.value.isYourReserverd =
                                _message.data!.isYourReserverd
                        }

                        if (_message.data!.isHavePeopleReserverd === -1) {
                            deskData.value.gameTable.reserverd = 0
                            deskData.value.reserverdType = undefined
                        } else if (_message.data!.isHavePeopleReserverd === 1) {
                            deskData.value.gameTable.reserverd = 1
                            deskData.value.reserverdType =
                                _message.data!.reserverdType
                            // TODO: test
                            if (_message.data!.isYourReserverd === -1) {
                                kickUserOffTheTable()
                            }
                        }
                    }
                }
            } else if (_type === SOCKET_MESSAGE.GUNNER_GIVEFREE) {
                const sDesk = gameTable!
                if (_message.data.tableId === deskData.value!.gameTable.id) {
                    const _evt: MessageBoxEvent = {
                        type: MessageBoxActionType.open,
                        name: 'tipbox-concent'
                    }
                    emitter.emit(EventBuss.DIALOG, _evt)
                    setTimeout(() => {
                        const {
                            feeAmount,
                            tableId,
                            title,
                            content,
                            tableNo,
                            memberId,
                            status
                        } = _message.data
                        emitter.emit(EventBuss.TIP_CONCENT_DATA, {
                            feeAmount,
                            tableId,
                            title,
                            content,
                            tableNo,
                            memberId,
                            status
                        })
                    }, 150)
                }
            } else if (_type === SOCKET_MESSAGE.MEMBER_PLAY && deskData.value) {
                const { memberId, status, tableNo, content } = _message.data

                emitter.emit(EventBuss.SMALL_TOAST, content)
                // play
                if (
                    status === 19 &&
                    tableNo === deskData.value.gameTable.tableNo
                ) {
                    deskData.value.gameTable.pauseStatus = 0
                    deskData.value.gameTable.pauseMemberId = 0
                } else if (status === 18) {
                    deskData.value.gameTable.pauseStatus = -1
                    deskData.value.gameTable.pauseMemberId = memberId
                }
            } else if (_type === SOCKET_MESSAGE.TABLE_VISIT_STATUS) {
                const _tbId = (_message as any).tableId
                if (deskData.value && deskData.value.gameTable.id === _tbId) {
                    deskData.value.gameTable.visitCode = (
                        _message as any
                    ).visitCode

                    //  deskData.value.isYourReserverd === -1

                    if (deskData.value.gameTable.reserverd === 1) {
                        if (
                            userInfo.value &&
                            deskData.value.gameTable.visitCode
                        ) {
                            const visitCodes =
                                deskData.value.gameTable.visitCode.split(',')
                            if (visitCodes.indexOf(userInfo.value.code) == -1) {
                                kickUserOffTheTable()
                                return
                            }
                        }
                    }
                }
            } else if (_type === SOCKET_MESSAGE.STOP_BET) {
                const sDesk = gameTable!
                if (isSameTable(sDesk, _type)) {
                    const _gtableCopy = { ...deskData.value!.gameTable }
                    _gtableCopy.expand.stopBet = 1
                    _gtableCopy.expand.openPoke = -1
                    deskData.value!.gameTable = _gtableCopy

                    if (refBetGroup.value) {
                        setTimeout(() => {
                            refBetGroup.value.resetTempBet()
                        }, 250)
                    }

                    if (userCommandType.value === 1) {
                        audioPlayer.Play(SOUNDKEY.STOP_BET)
                        emitter.emit(EventBuss.GAMESTATUS, 2)
                    }
                }
            }
        }

        const isSameTable = (_table: TableData, _type = ''): boolean => {

            if (deskData.value && deskData.value.gameTable.id === _table.id) {

                const isDebugLogEnabled = process.env.ENABLE_DEBUG_LOG === 'true'
                if (_type !== '' && isDebugLogEnabled) {
                    console.log(`TYPE: ${_type} TABLE: ${_table.tableNo} ID: ${_table.id}`)
                }
                return true
            }
            else return false
        }

        const isStaleBetMessage = (sDesk: TableData): boolean => {
            const table = deskData.value?.gameTable
            if (!table) return true
            const incomingNo = sDesk.expand?.gameNo
            const currentNo = table.expand?.gameNo
            return !!(
                incomingNo &&
                currentNo &&
                String(incomingNo) !== String(currentNo)
            )
        }

        const canPaintConfirmedChips = (): boolean => {
            const table = deskData.value?.gameTable
            if (!table || !refBetGroup.value) return false
            if (table.status !== 1) return false
            const whoWin = table.expand?.whoWin
            if (whoWin !== undefined && whoWin !== -1) return false
            return true
        }

        const logEnGameCardResult = (deskResult: GameResult, sDesk: TableData): void => {
            const now = new Date()
            const timeString =
                `${String(now.getHours()).padStart(2, '0')}:` +
                `${String(now.getMinutes()).padStart(2, '0')}:` +
                `${String(now.getSeconds()).padStart(2, '0')}.` +
                `${String(now.getMilliseconds()).padStart(3, '0')}`

            // const rankNames: Record<number, string> = {
            //     1: 'A',
            //     11: 'J',
            //     12: 'Q',
            //     13: 'K'
            // }
            // const suitFaces: Record<string, { symbol: string; color: string }> =
            // {
            //     '1': { symbol: '♠', color: '#111' },
            //     '2': { symbol: '♥', color: '#e11' },
            //     '3': { symbol: '♣', color: '#111' },
            //     '4': { symbol: '♦', color: '#e11' }
            // }
            // const toCardFace = (
            //     code: string
            // ): { face: string; style: string } => {
            //     if (!code || code.length < 3) {
            //         return { face: code, style: 'font-weight:bold' }
            //     }
            //     const rankNum = parseInt(code.substr(1, 2), 10)
            //     const rank = rankNames[rankNum] || String(rankNum)
            //     const suit = suitFaces[code.charAt(0)] || {
            //         symbol: '',
            //         color: '#111'
            //     }
            //     return {
            //         face: `${rank}${suit.symbol}`,
            //         style:
            //             `color:${suit.color};background:#f5f0e6;` +
            //             'font-weight:bold;font-size:12px'
            //     }
            // }

            // const playerHands = deskResult.blueCard.map(toCardFace)
            // const bankerHands = deskResult.redCard.map(toCardFace)
            // const formatHands = (
            //     cards: { face: string; style: string }[]
            // ) => ({
            //     text: cards.map((card) => `%c${card.face}%c`).join(' '),
            //     styles: cards.flatMap((card) => [card.style, ''])
            // })
            // const player = formatHands(playerHands)
            // const banker = formatHands(bankerHands)

            // console.log(sDesk)

            // log out  time, tableNo, gameNo, cards number

            console.log(
                `END_GAME ${timeString} tableNo:${sDesk.tableNo || ''} gameNo:${sDesk.expand?.gameNo || ''} cards number: player:${deskResult.blueCard.toString()} banker:${deskResult.redCard.toString()}`
                // ${deskResult.blueCard.length} ${player.text}%c : ${banker.text}`,
                // ...player.styles,
                // 'color:#888',
                // ...banker.styles
            )
        }



        const kickUserOffTheTable = () => {
            const _evt: MessageBoxEvent = {
                type: MessageBoxActionType.open,
                name: 'prompt'
            }
            emitter.emit(EventBuss.DIALOG, _evt)
            setTimeout(() => {
                emitter.emit(EventBuss.MESSAGE, {
                    message: t('prompts.tablecloseforaccess'),
                    callback: () => {
                        //
                    }
                })
            }, 100)
            router.push({
                name: ROUTES.LOBY
            })
        }
        //#endregion

        const redCount = computed(() => {
            if (roadMapData.value) return roadMapData.value.redCount
            return 0
        })

        const blueCount = computed(() => {
            if (roadMapData.value) return roadMapData.value.blueCount
            return 0
        })

        const greenCount = computed(() => {
            if (roadMapData.value) return roadMapData.value.tieCount
            return 0
        })

        const redPairCount = computed(() => {
            if (roadMapData.value) return roadMapData.value.redPairCount
            return 0
        })

        const bluePairCount = computed(() => {
            if (roadMapData.value) return roadMapData.value.bluePairCount
            return 0
        })

        const token = computed(() => store.getters['token'])
        const user = computed(() => store.getters['user'])
        const coin = computed(() => store.getters['coin'])
        const memberid = computed(() => store.getters['memberid'])
        const soundIsOn = computed(() => store.getters['soundEffect'] === 1)
        const videoIsOn = computed(() => store.getters['videoIsOn'])

        const isMobile = computed(() => store.getters['isMobile'])
        const rebateType = computed((): number => {
            return store.getters['rebateType']
        })

        const deviceOrientation = computed(
            () => store.getters['deviceOrientation']
        )

        const mapData = computed(() => {
            if (deskData.value)
                return deskData.value.gameTable.expand.resultList
            return []
        })

        const timerColor = computed(() => {
            let _color = ''
            if (currentCount.value > 20) {
                _color = 'green'
            } else if (currentCount.value > 10 && currentCount.value <= 20) {
                _color = 'orange'
            } else if (currentCount.value <= 10 && currentCount.value >= 0) {
                _color = 'red'
            }

            return _color
        })

        const isFreeUser = computed(() => store.getters['isFreeUser'])
        const visitorTable = computed(
            (): number[] => store.getters['visitorTable']
        )

        const shoeRound = computed(() => {
            if (deskData.value)
                return `${deskData.value.gameTable.expand.shoeNo}/${deskData.value.gameTable.expand.juNo}`

            return '0'
        })

        const deskOptions = computed(
            (): Array<{ gameType: number; name: string; id: number }> =>
                store.getters['deskOptions']
        )

        const redAskLabel = computed(() => {
            let _label = ''

            return _label
        })

        const blueAskLabel = computed(() => {
            let _label = ''

            return _label
        })

        const gameType = computed(() => {
            if (deskData.value)
                return deskData.value.gameTable.gameTypeNo.toUpperCase()

            return 'G002'
        })

        const redBlueLimit = computed(() => {
            if (deskData.value) {
                const { downLimit, upLimit } = deskData.value.gameTable
                return `${downLimit}-${upLimit}`
            }
            return '0:0'
        })
        const pairLimit = computed(() => {
            if (deskData.value) {
                const { pairDownLimit, pairUpLimit } = deskData.value.gameTable
                return `${pairDownLimit}-${pairUpLimit}`
            }
            return '0:0'
        })
        const greenLimit = computed(() => {
            if (deskData.value) {
                const { tieDownLimit, tieUpLimit } = deskData.value.gameTable
                return `${tieDownLimit}-${tieUpLimit}`
            }
            return '0:0'
        })
        const dragonSevenLimit = computed(() => {
            if (deskData.value) {
                const { dragonSevenDownLimit, dragonSevenUpLimit } = deskData.value.gameTable
                return `${dragonSevenDownLimit}-${dragonSevenUpLimit}`
            }
            return '0:0'
        })
        const bearEightLimit = computed(() => {
            if (deskData.value) {
                const { bearEightDownLimit, bearEightUpLimit } = deskData.value.gameTable
                return `${bearEightDownLimit}-${bearEightUpLimit}`
            }
            return '0:0'
        })
        const bigTigerLimit = computed(() => {
            if (deskData.value) {
                const { bigTigerDownLimit, bigTigerUpLimit } = deskData.value.gameTable
                return `${bigTigerDownLimit}-${bigTigerUpLimit}`
            }
            return '0:0'
        })
        const smallTigerLimit = computed(() => {
            if (deskData.value) {
                const { smallTigerDownLimit, smallTigerUpLimit } = deskData.value.gameTable
                return `${smallTigerDownLimit}-${smallTigerUpLimit}`
            }
            return '0:0'
        })
        const superSixLimit = computed(() => {
            if (deskData.value) {
                const { superSixDownLimit, superSixUpLimit } = deskData.value.gameTable
                return `${superSixDownLimit}-${superSixUpLimit}`
            }
            return '0:0'
        })

        const tableName = computed(() => {
            if (deskData.value) {
                const { gameTypeNo, tableNo, fastType } = deskData.value.gameTable
                const prefix =
                    fastType === 1 ? t('loby.fast') : t('loby.classic')

                if (gameTypeNo.toUpperCase() === 'G002')
                    return `${prefix}${t(
                        'loby.baccarattable'
                    )} ${tableNo} (${commandType()})`
                else
                    return `${t(
                        'loby.dragontigertable'
                    )} ${tableNo} (${commandType()})`
            }
            return ''
        })

        const gameid = computed(() => {
            if (deskData.value) {
                return deskData.value.gameTable.expand.gameNo
            }

            return '0'
        })

        const isReserved = computed(() => {
            if (deskData.value) {
                return deskData.value.gameTable.reserverd > 0
            }

            return false
        })

        const commandTypeAndGameId = computed(() => {
            if (deskData.value) {
                return `${commandType()} (${t('game.gameid')}: ${deskData.value.gameTable.expand.gameNo
                    })`
            }
            return ''
        })

        const cardResultData = computed(() => {
            if (deskData.value) return deskData.value.gameTable
            return undefined
        })

        const gameTable = computed(() => {
            if (deskData.value) return deskData.value.gameTable

            return undefined
        })

        const callGunnerText = computed(() => {
            if (deskData.value) {
                const callGunner = deskData.value.gameTable.expand.callGunner
                if (callGunner && callGunner === 2) return '无声'
                else if (callGunner && callGunner === 1) return '有声'
            }

            return '无声'
        })

        const isInThisTable = computed(() => {
            if (deskData.value)
                return deskData.value.gameTable.expand.memberStatus === 3
            return false
        })

        const isBindToGunner = computed(() => store.getters['isGunner'] !== 0)

        const isfullScreen = computed(() => store.getters['isfullScreen'])

        const userCommandType = computed(() => store.getters['commandType'])
        const userInfo = computed((): UserInfo => store.getters['userInfo'])
        const tableCanReserved = computed(() => {
            if (deskData.value) {
                if (deskData.value.isYourReserverd === 1) return true

                if (
                    userCommandType.value === 1 &&
                    deskData.value.gameTable.reserverd === 1
                )
                    return false

                // if(userCommandType.value ===2 && deskData.value.gameTable.reserverd === 1 && )
                if (
                    deskData.value.reserverdType &&
                    deskData.value.reserverdType === 1 &&
                    userCommandType.value === 2
                )
                    return false
                return deskData.value.gameTable.reserverd !== -1
            }

            return false
        })

        const gameIsPaused = computed(() => {
            if (deskData.value) {
                return deskData.value.gameTable.pauseStatus === -1
            }
            return false
        })

        const vipButtontext = computed(() => {
            if (deskData.value)
                return deskData.value.isYourReserverd === 1
                    ? '取消包台'
                    : '包台'
            return '包台'
        })

        const showTableControls = computed((): boolean => {
            if (isFreeUser.value) return false
            if (userCommandType.value === 2) return true

            if (
                deskData.value &&
                deskData.value.reserverdType &&
                deskData.value.reserverdType === 2 &&
                userCommandType.value === 1
            ) {
                return false
            }

            if (isBindToGunner.value && isInThisTable.value) {
                return true
            }

            if (deskData.value && deskData.value.isYourReserverd === 1)
                return true

            return false
        })

        const tooggleGameMode = (isFree: boolean) => {
            isFreeBaccarat.value = isFree
        }

        const showChipControls = computed((): boolean => {
            // if (isFreeUser.value) return false
            if (userCommandType.value === 2) return true

            if (
                deskData.value &&
                deskData.value.reserverdType &&
                deskData.value.reserverdType === 2 &&
                userCommandType.value === 1
            ) {
                return false
            }

            if (isBindToGunner.value && isInThisTable.value) {
                return true
            }

            return false
        })

        const isYoureReserved = computed((): boolean => {
            if (deskData.value) return deskData.value.isYourReserverd === 1
            return false
        })
        const fullScreenAvailable = computed(() => screenfull.isEnabled)

        const enableOpenPokerOP = computed(() => {
            if (deskData.value && userCommandType.value !== 1) {
                return (
                    deskData.value.gameTable.status === 1 &&
                    isPokerOpenFlag.value === 4
                )
                // return true
            } else if (
                deskData.value &&
                userCommandType.value === 1 &&
                deskData.value.gameTable.expand.stopBet !== 1
            ) {
                return (
                    (deskData.value.gameTable.status === 1 ||
                        deskData.value.gameTable.status === 2) &&
                    isPokerOpenFlag.value === 4
                )
            }
            return false
        })

        // const rebetIds = computed((): string[] => store.getters['rebetIds'])
        // const lastBet = computed((): BetItem[] => store.getters['lastBet'])

        const prevBets = computed(
            (): Dictionary<BetItem[]> => store.getters['prevBets']
        )
        const highlightSwitchPlayMode = computed(() => store.getters['highlightSwitchPlayMode'])

        const onBetModeChange = (_isFreeBaccarat: boolean) => {
            isFreeBaccarat.value = _isFreeBaccarat
            allowToggleGameMode.value = false
        }

        const canRepeatBet = computed((): boolean => {
            // check if there is a data available
            if (typeof deskData.value === 'undefined') return false

            //  check if has a previouse bets
            if (prevBets.value.Count() <= 0) return false

            // check if prev bets has more than 2 records
            const has1MoreItem = prevBets.value.Count() >= 2

            // check if last bet is same as the curent game
            const lastKey = prevBets.value.LastItemKey()

            if (lastKey === deskData.value.gameTable.expand.gameNo) {
                if (!has1MoreItem) {
                    return false
                } else {
                    return (
                        !isRepeatBetClicked.value &&
                        deskData.value.gameTable.status === 1
                    )
                }
            } else {
                return (
                    !isRepeatBetClicked.value &&
                    deskData.value.gameTable.status === 1
                )
            }
        })

        const btnJoinTableLabel = computed(() => {
            if (isFreeUser.value) return '访客登录，无法进行投注'
            else {
                return hasJoinRequest.value
                    ? '等待枪手处理中...'
                    : '点击转入此桌'
            }
        })

        watch(
            () => deviceOrientation.value,
            () => {
                showSwitcher.value = false
            }
        )

        watch(
            () => videoIsOn.value,
            (v) => {
                if (v !== deskVideoOn.value) {
                    deskVideoOn.value = v

                    if (deskVideoOn.value) {
                        if (deskData.value) initVideoPlayer()
                    } else {
                        disposeVideoPlayer()
                    }
                }
            }
        )

        watch(
            () => [
                deskData.value?.gameTable.expand.daoJiShiBetTime,
                deskData.value?.gameTable.status
            ],
            ([daoJiShiBetTime]) => {
                if (daoJiShiBetTime != null && daoJiShiBetTime > 0) {
                    allowToggleGameMode.value = true
                    startCountDown()
                } else if (deskData.value) {
                    stopCountDown()
                }
            }
        )

        return {
            highlightSwitchPlayMode,
            isRepeatBetClicked,
            canRepeatBet,
            hasUnConfirmedBet,
            showMobileFunctionControls,
            refVideoContainer,
            refFullVideo,
            refMinVideo,
            isFullVideo,
            isMobile,
            mapData,
            roadmapview1,
            roadmapview2,
            roadMapData,
            nextRedRoadMapSummaryData,
            nextBlueRoadMapSummaryData,
            rebateType,

            currentCount,
            timerColor,
            user,
            coin,
            soundIsOn,
            videoIsOn,
            deskVideoOn,

            shoeRound,
            deskNotice,
            deskNoticeKey,
            blueCount,
            redCount,
            greenCount,
            bluePairCount,
            redPairCount,
            redBlueLimit,
            pairLimit,
            greenLimit,
            dragonSevenLimit,
            bearEightLimit,
            bigTigerLimit,
            smallTigerLimit,
            superSixLimit,
            tableName,
            gameid,
            isReserved,
            commandTypeAndGameId,
            cardResultData,
            cardResultKey,
            isBindToGunner,
            isInThisTable,
            callGunnerText,
            hasJoinRequest,
            tableCanReserved,
            deskMapKey,
            showSimpleResult,
            showCardDisplay,
            showMediaControl,
            showSwitchDesk,
            vipButtontext,
            userCommandType,
            gameIsPaused,
            showTableControls,
            showChipControls,
            isYoureReserved,
            enableOpenPoker,
            showResultPreview,
            btnJoinTableLabel,

            deskOptions,
            redAskLabel,
            blueAskLabel,
            gameType,
            isLoadingVideo,
            isScaleVideo,
            isfullScreen,
            fullScreenAvailable,
            isFreeBaccarat,
            allowToggleGameMode,
            gameTable,
            betViewKey,
            refBetGroup,
            enableOpenPokerOP,
            enableFreeBaccarat,
            toMultibeting,
            onToggleMediaControl,
            hideSwitcher,
            onRoadMapDataParsed,
            predict,
            t,
            onToggleVideo,
            showSettingDialog,
            requestFullScreen,
            toggleSoundEffect,
            hideSwitchTable,
            onSwitchTable,
            joinTable,
            callGunnerFunc,
            callOperatStatus,
            callFlyBet,
            showTipBox,
            callReservedOrCancellReserved,
            callPauseRequest,
            onPlaceTempBetOrClear,
            onBetSuccess,
            callOpenPokeRequest,
            handleOnMapPreview,
            toggleFullVideo,
            confirmBet,
            cancelBet,
            repeatBet,
            tooggleGameMode,
            onBetModeChange,
            switchPlayMode
        }
    }
})
